export default "__VITE_ASSET__CloyKLjb__"